
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolonavalainnovacrystacabstaxi() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Innova Crysta Cabs Taxi',
        heading: 'Meghana Cab : Pune to Lonavala Innova Crysta Cabs Taxi',
        headingDescription: 'Meghana Cab offers Pune to Lonavala Innova Crysta Taxi Service, ensuring a luxurious, comfortable, and timely journey to the scenic hill station. Covering roughly 65–70 km via the Mumbai–Pune Expressway in about 1.5 hours, our Innova Crysta vehicles feature plush leather interiors, ample legroom, air-conditioned cabins, and generous luggage compartments—ideal for family outings, group trips, or romantic getaways . With professional chauffeurs, door-to-door pickups from any location in Pune, GPS-enabled vehicles, and transparent booking options (one-way, round-trip, or hourly rentals), Meghana Cab ensures your travel is smooth and stress-free. Rely on our 24/7 customer support for seamless planning and enjoy the beauty of the Western Ghats in style and comfort.',


        top: 'Top Places to Visit in Lonavala with Meghana Cab',

"topPlaces": [
  {
    "title": "Tiger’s Leap",
    "description": "A dramatic cliff perched over 650 m above the valley, Tiger’s Leap offers panoramic views of the Western Ghats and a seasonal waterfall cascading over the precipice. The location’s folklore—where Shivaji is said to have leapt from this cliff—adds to its mystique. A favorite spot for monsoon treks, sunrise/sunset watchers, and photographers."
  },
  {
    "title": "Lohagad Fort",
    "description": "Built in the 10th century and fortified by Chatrapati Shivaji in the 17th century, Lohagad Fort is a trekking favorite. Known for its broad ‘Vinchu Wada’ wall and panoramic views of the Pawna dam and valley, it's accessible via a well-maintained staircase. The fort is especially lush and misty during monsoon."
  },
  {
    "title": "Rajmachi Fort (Shrivardhan & Manaranjan Citadels)",
    "description": "Midway between Lonavala and Khandala, the twin forts of Rajmachi overlook dense forests and misty valleys. Hikers enjoy exploring both Shrivardhan (900 m high) and Manaranjan forts, with shaded trails, ancient ruins, and seasonal springs. Best visited during shoulder months."
  },
  {
    "title": "Bhushi Dam",
    "description": "Built in the late 1860s to supply water to steam engines, Bhushi Dam is now a monsoon pilgrimage spot. Tourists wade into its cascading steps, picnic around its banks, and enjoy the green hillside ambiance. Access is restricted in the evenings for safety :contentReference[oaicite:2]{index=2}."
  },
  {
    "title": "Karla & Bhaja Caves",
    "description": "Rock-cut Buddhist cave complexes dating back to 2nd century BCE, located a few kilometers from Lonavala. Karla boasts the largest Chaitya hall (Cave 8), while Bhaja has 22 caves, stupas, and rock-cut architecture. Both heritage sites offer a touch of ancient history amid forested hills :contentReference[oaicite:3]{index=3}."
  },
  {
    "title": "Pawna Lake",
    "description": "An idyllic reservoir formed by Pawna Dam, Pawna Lake is popular for camping, lakeside picnics, and stargazing. The setting is tranquil, opening into endless sky and lush hills—perfect for romantic getaways, group retreats, and outdoor eateries."
  },
  {
    "title": "Della Adventure Park",
    "description": "India’s largest adventure park (36 acres) near Kunegaon, offering 50+ activities—zipline, ATV rides, archery, and glamping. With resort stay, dining options, and curated experiences, it’s a family-&-thrill-seeker hotspot :contentReference[oaicite:4]{index=4}."
  },
  {
    "title": "Tiger’s & Lion’s Point + Glass Skywalk",
    "description": "These twin cliff viewpoints offer breathtaking panoramas and are soon to be connected by a glass skywalk under the ₹909 cr PMRDA tourism initiative—boasting rooftop cafés, parking, and improved access :contentReference[oaicite:5]{index=5}."
  },
  {
    "title": "Bhushi & Lonavala Lake",
    "description": "Lonavala Lake fills with rainwater during monsoon and offers peaceful bird-watching and angling spots. A gentle walking route makes it ideal for early morning strolls."
  },
  {
    "title": "Sunil’s Celebrity Wax Museum & Narayani Dham",
    "description": "These adjacent attractions—Sunil’s Celebrity Wax Museum (with wax figures of famous personalities) and the white-marble Narayani Dham temple—are popular for short, family-friendly visits :contentReference[oaicite:6]{index=6}."
  }
],

      "services": [
    {
      "name": "Pune to Lonavala Innova Crysta Cab Booking",
      "description": "Plan a relaxing getaway from Pune to Lonavala with our premium Innova Crysta cab booking service. Enjoy door-to-door pickup, spacious seating, AC comfort, and scenic views along the expressway. Ideal for families, couples, and groups seeking a comfortable travel experience to the hills."
    },
    {
      "name": "One Way Innova Crysta Pune Lonavala",
      "description": "Book a one-way Innova Crysta taxi from Pune to Lonavala for a smooth and hassle-free journey. Our professional drivers ensure safe travel on the Mumbai-Pune expressway, and you only pay for one side—perfect for quick plans or drop-offs."
    },
    {
      "name": "Round Trip Innova Crysta Pune Lonavala",
      "description": "Planning a day trip or weekend in Lonavala? Choose our round-trip Innova Crysta cab for convenience and value. You get a reliable ride, driver availability throughout the trip, and ample time to explore attractions like Tiger’s Point and Bhushi Dam."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Lonavala",
      "description": "Travel comfortably in our air-conditioned Innova Crysta taxis from Pune to Lonavala. Perfect for escaping the city heat and humidity, our AC cabs ensure a cool, smooth ride whether you're traveling solo or with a group."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Lonavala",
      "description": "Relax and enjoy the scenic drive as our trained chauffeurs take you from Pune to Lonavala in a well-maintained Innova Crysta. Courteous drivers, punctual service, and local route knowledge make your trip safe and enjoyable."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Lonavala",
      "description": "Enjoy privacy and comfort in our private Innova Crysta taxis from Pune to Lonavala. No ride sharing, no delays—just a clean, spacious SUV at your service for a personalized travel experience."
    },
    {
      "name": "Online Booking Innova Crysta Pune Lonavala",
      "description": "Easily book your Pune to Lonavala Innova Crysta cab online. With real-time availability, transparent pricing, and instant confirmation, our platform makes planning your trip simple and secure."
    },
    {
      "name": "Lonavala Tour Innova Crysta",
      "description": "Explore the best of Lonavala with our tour package in a comfortable Innova Crysta. Ideal for sightseeing lovers, our tour covers top spots like Rajmachi Fort, Karla Caves, and Lion’s Point, all in a single day or weekend plan."
    },
    {
      "name": "Family Trip Innova Crysta Pune Lonavala",
      "description": "Take your family on a cozy trip to Lonavala in our 6- or 7-seater Innova Crysta. Spacious interiors, child-safe seating, and luggage room ensure a stress-free and enjoyable journey for the entire family."
    },
    {
      "name": "Weekend Trip Cab Pune to Lonavala",
      "description": "Planning a quick weekend break? Book our Innova Crysta for a weekend Pune-Lonavala trip with flexible return options and full-day driver availability. A perfect escape into nature with luxurious travel."
    },
    {
      "name": "Affordable Innova Crysta Taxi Lonavala",
      "description": "Looking for cost-effective yet premium travel? Our affordable Innova Crysta taxis offer competitive rates for your Pune to Lonavala journey—ideal for students, small groups, or frequent travelers."
    },
    {
      "name": "Comfortable Innova Crysta Pune Lonavala Cab",
      "description": "Experience exceptional comfort in our Innova Crysta cabs from Pune to Lonavala. With reclining seats, climate control, and ample legroom, your 2-hour drive becomes a smooth ride you’ll enjoy."
    },
    {
      "name": "Luxury Innova Crysta Lonavala Taxi",
      "description": "Travel in style with our luxury Innova Crysta taxi service to Lonavala. Enjoy plush seating, leather interiors, bottle holders, and an executive feel—all while soaking in the views of the Western Ghats."
    },
    {
      "name": "Lonavala Sightseeing Innova Crysta",
      "description": "Hire an Innova Crysta specifically for Lonavala sightseeing. Cover key attractions like Bushi Dam, Lonavala Lake, and Wax Museum without rushing, with a dedicated driver for your chosen duration."
    },
    {
      "name": "Reliable Pune Lonavala Innova Crysta Cab",
      "description": "Count on us for reliable Pune to Lonavala Innova Crysta cab service. Our vehicles are serviced regularly, drivers are verified, and booking support is available 24/7 for your peace of mind."
    }
  ],
  "tableData": [
    ["Pune to Lonavala Innova Crysta Cab Booking", "One Way Innova Crysta Pune Lonavala"],
    ["Round Trip Innova Crysta Pune Lonavala", "AC Innova Crysta Taxi Pune Lonavala"],
    ["Chauffeur Driven Innova Crysta Pune Lonavala", "Private Innova Crysta Taxi Pune Lonavala"],
    ["Online Booking Innova Crysta Pune Lonavala", "Lonavala Tour Innova Crysta"],
    ["Family Trip Innova Crysta Pune Lonavala", "Weekend Trip Cab Pune to Lonavala"],
    ["Affordable Innova Crysta Taxi Lonavala", "Comfortable Innova Crysta Pune Lonavala Cab"],
    ["Luxury Innova Crysta Lonavala Taxi", "Lonavala Sightseeing Innova Crysta"],
    ["Reliable Pune Lonavala Innova Crysta Cab", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Taxi from Pune to Lonavala",
    "WhyChoosedescription": "Book our spacious and comfortable Innova Crysta cab for a relaxing trip from Pune to Lonavala. Whether it’s a weekend escape, family trip, or corporate outing, we provide a smooth, stylish, and comfortable ride for this 65–70 km scenic journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Ride for Group Travel",
    "WhyChoosedescription": "With seating for 6–7 passengers, reclining seats, ample luggage space, and dual AC, Innova Crysta is ideal for group travel. Whether you're heading to a resort, farmhouse, or sightseeing in the hills, enjoy a peaceful, spacious journey."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our trained drivers are familiar with the Pune–Lonavala route and ensure a safe and smooth ride through the expressway. They are punctual, courteous, and ready to accommodate custom stops or sightseeing on the way."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our Innova Crysta cabs are thoroughly cleaned and sanitized before every ride. We maintain high hygiene and safety standards to make sure you travel in a vehicle that’s as fresh and well-kept as your destination deserves."
  },
  {
    "WhyChooseheading": "Flexible Booking – One-Way, Round Trip or Day Rentals",
    "WhyChoosedescription": "Whether you need a one-way drop, same-day return, or wish to explore Lonavala for the day, we offer flexible booking options. Customize your trip duration, stops, and pickup/drop locations easily."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and all-inclusive fares covering fuel, tolls, driver allowance, and taxes. No last-minute surprises—just honest, upfront pricing for a luxury intercity experience."
  },
  {
    "WhyChooseheading": "Perfect for Weekend Getaways and Quick Breaks",
    "WhyChoosedescription": "Innova Crysta is a favorite choice for families and groups planning a short trip to Lonavala’s waterfalls, dams, hill viewpoints, and theme parks. Travel in comfort and avoid the fatigue of driving yourself."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
    "WhyChoosedescription": "We’re available around the clock for bookings, reschedules, or travel-related questions. Our dedicated team ensures a seamless cab booking experience from Pune to Lonavala and back."
  }
]
















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Lonavala?",
        answer: "Booking is easy! Call Meghana Cab at +91 9075462128 or visit our website to reserve your ride instantly."
    },
    {
        question: "What is the distance and travel time between Pune and Lonavala?",
        answer: "The distance is around 65 km, and travel time is approximately 1.5 to 2 hours depending on traffic."
    },
    {
        question: "Is Innova Crysta a good option for Pune to Lonavala trips?",
        answer: "Yes, the Innova Crysta is ideal for group or family trips with excellent comfort, air conditioning, and luggage space."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, you can book both one-way and round-trip cabs as per your travel plan."
    },
    {
        question: "How many passengers can travel in the Innova Crysta?",
        answer: "It accommodates 6 to 7 passengers comfortably along with luggage."
    },
    {
        question: "Are cabs sanitized before each trip?",
        answer: "Yes, all our cabs are thoroughly sanitized before every journey to ensure safety and hygiene."
    },
    {
        question: "Are tolls and driver charges included in the fare?",
        answer: "Yes, our standard fare includes fuel, driver charges, and tolls. Parking and waiting may incur extra charges."
    },
    {
        question: "Can I request stops for sightseeing or meals during the journey?",
        answer: "Yes, custom stops can be arranged. Please inform us during the booking for smooth planning."
    },
    {
        question: "Do your drivers have experience on the Pune-Lonavala route?",
        answer: "Absolutely. Our drivers are well-versed with the route and ensure a safe, enjoyable ride."
    },
    {
        question: "What payment options are available?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We had a smooth trip from Pune to Lonavala. The Innova Crysta was comfortable and the driver was punctual and polite.”',
    },
    {
        name: 'Ms. Snehal Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service by Meghana Cab! Clean and luxurious Crysta, perfect for our family’s Lonavala weekend getaway.”',
    },
];



























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const puneLonavalaInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Lonavala Innova Crysta Cabs Taxi Service",
  "description": "Book affordable and comfortable Innova Crysta cabs from Pune to Lonavala. Ideal for one-way, round trips, family tours, sightseeing, and weekend getaways with chauffeur-driven luxury service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Lonavala"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-lonavala-innova-crysta-cab"
  }
};









    return (
        <div>
<Helmet>
  <title>Pune to Lonavala Innova Crysta Cabs | Taxi Booking & Rental</title>
  <meta
    name="description"
    content="Book Innova Crysta taxi from Pune to Lonavala for comfortable, affordable, and luxury travel. Perfect for family trips, sightseeing, and weekend getaways with chauffeur-driven service."
  />
  <meta
    name="keywords"
    content="Pune to Lonavala Innova Crysta Cab Booking, One Way Innova Crysta Pune Lonavala, Round Trip Innova Crysta Pune Lonavala, AC Innova Crysta Taxi Pune Lonavala, Chauffeur Driven Innova Crysta Pune Lonavala, Private Innova Crysta Taxi Pune Lonavala, Online Booking Innova Crysta Pune Lonavala, Lonavala Tour Innova Crysta, Family Trip Innova Crysta Pune Lonavala, Weekend Trip Cab Pune to Lonavala, Affordable Innova Crysta Taxi Lonavala, Comfortable Innova Crysta Pune Lonavala Cab, Luxury Innova Crysta Lonavala Taxi, Lonavala Sightseeing Innova Crysta, Reliable Pune Lonavala Innova Crysta Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneLonavalaInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolonavalainnovacrystacabstaxi;